import { Handle, Position, Node, NodeProps } from "@xyflow/react"
import { ScenarioNodeData } from "@/gen"
import { cn } from "@/lib/utils"

type GhostNodeType = Node<ScenarioNodeData & Record<string, unknown>, "ghost">

function GhostNode(props: NodeProps<GhostNodeType>) {
  return (
    <div className={cn("size-20 fc")}>
      <div className="absolute left-0 right-0 size-20 rounded-3xl border-[5px] border-background bg-[var(--xy-edge-stroke)] shadow-node fc animate-jump-in animate-duration-300"></div>
      <div className="z-10 fc">
        <Handle type="target" position={Position.Left} isConnectable={false} className="!opacity-0 -!left-10" />
        <IconSolarPlugCircleBold
          className={`
            size-10 animate-wiggle-more text-white animate-infinite

            [&_path]:stroke-[2.5px]
          `}
        />
      </div>
    </div>
  )
}

export default GhostNode
